<template>
  <div class="news-list">
    <div class="header container">
      <view-back></view-back>
    </div>
    <div class="banner-box container">
      <div class="flower1"></div>
      <div class="flower2"></div>
      <img class="logo" src="../../assets/images/live-logo.png" alt="">
    </div>

    <!--切换头部-->
    <div class="tab-box">
      <div class="wrap">
        <p class="selected">新闻报道</p>
      </div>
    </div>

    <div class="news-list-box">
      <div class="search-result-box wrap">
        <div class="list-box0 wrap" v-if="list.length > 0">
          <ul class="clearfix">
            <li v-for="(item, index) in list" :key="index" @click="gotoNews(item.articleUrl)">
              <div class="cover">
                <img :src="item.cover" alt="">
              </div>
              <p class="title omitline1">{{item.title}}</p>
              <p class="time omitline1">{{item.updateTime}}</p>
            </li>
          </ul>
          <div class="loading">
            <img v-if="isloading" src="../../../public/gif/loading.gif" alt="">
          </div>
        </div>
        <div class="no-search wrap" v-if="list.length === 0">
          <div class="box">
            <img :src="noData" alt="">
            <div>暂无新闻</div>
          </div>
        </div>
      </div>
    </div>

    <div class="live-top-btn" @click="returnTop"></div>
  </div>
</template>

<script>
import ViewBack from '../../components/ViewBack'
import noData from '../../assets/images/no-data.png'
let scrollListener = null
export default {
  name: 'News',
  components: {
    'view-back': ViewBack
  },
  data () {
    return {
      noData: noData,
      isloading: false,
      currentIndex: 0, // 默认专题介绍
      list: [],
      offset: 0,
      // limit: 100000,
      limit: 20,
      currentPage: 1,
      total: 0
    }
  },
  created () {
    this.getNewsList()
    setTimeout(() => {
      let scrollAction = { x: undefined, y: undefined }
      scrollListener = () => {
        let scrollDom = document.documentElement || document.body
        if (typeof scrollAction.y === 'undefined') {
          scrollAction.y = scrollDom.scrollTop
        }
        let diffY = scrollAction.y - scrollDom.scrollTop
        scrollAction.y = scrollDom.scrollTop
        if ((scrollDom.scrollTop + 5 >= scrollDom.scrollHeight - scrollDom.clientHeight) && this.list.length < this.total && diffY < 0) {
          this.isloading = true
          this.currentPage++
          this.getNewsList()
        }
      }
      this.util.addEvent(window, 'scroll', scrollListener)
    }, 1000)
  },
  beforeDestroy () {
    this.util.removeEvent(window, 'scroll', scrollListener)
  },
  mounted () {
  },
  methods: {
    gotoNews (url) {
      window.open(url, '_blank')
    },
    // 热门专题列表
    getNewsList () {
      let params = {
        offset: this.limit * (this.currentPage - 1),
        limit: this.limit,
        platform: 2 // 1.小程序小程序，2：中华文物云，3：博物馆网站
      }
      this.$api.getNewsList({ params: params }).then(res => {
        this.total = res.data.data.total
        if (this.currentPage === 1) {
          this.list = res.data.data.rows
        } else {
          this.isloading = false
          this.list = this.list.concat(res.data.data.rows)
        }
      })
    },
    returnTop () {
      let iSpeed = 0
      clearInterval(this.iTimer)
      this.iTimer = setInterval(() => {
        let heightTop = document.documentElement.scrollTop || document.body.scrollTop
        iSpeed = Math.floor((0 - heightTop) / 8)
        document.body.scrollTop = heightTop + iSpeed
        document.documentElement.scrollTop = heightTop + iSpeed
        if (document.body.scrollTop <= 0 && document.documentElement.scrollTop <= 0) {
          clearInterval(this.iTimer)
        }
      }, 30)
    }
  }
}
</script>

<style lang="scss">
  .news-list{
    min-width: 1200px;
    .banner-box{
      height: 300px;
      background: linear-gradient(134deg, #2A3239 0%, #54616B 100%);
      .logo{
        width: 120px;
        height: 123px;
        position: absolute;
        top: 89px;
        left: 245px;
      }
      .flower1{
        width: 500px;
        height: 235px;
        background: url("../../assets/images/live-flower1.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        left: -120px;
        bottom: 0;
      }
      .flower2{
        width: 589px;
        height: 300px;
        background: url("../../assets/images/live-flower2.png") no-repeat 0 0;
        background-size: 100% 100%;
        position: absolute;
        right: 0;
        bottom: 0;
      }
    }
    .tab-box{
      height: 72px;
      padding-top: 36px;
      box-shadow: 0 1px 10px 10px #f5f5f5;
      margin-bottom: 43px;
      .wrap{
        display: flex;
        justify-content: center;
      }
      p{
        display: inline-block;
        font-size: 24px;
        color: #9B9B9B;
        text-indent: 2px;
        letter-spacing: 2px;
        line-height: 24px;
        padding: 24px 0 ;
        position: relative;
        cursor: pointer;
        &.selected{
          color: #D7AE70;
          &::after{
            content: ' ';
            width: 60px;
            height: 4px;
            background: #D5AA68;
            position: absolute;
            left: 50%;
            bottom: 0;
            margin-left: -30px;
          }
        }
      }
    }

    .news-list-box{
      width: 980px;
      margin: 0 auto 60px;
      padding-bottom: 16px;
      position: relative;
      ul{
        li{
          float: left;
          width: 318px;
          height: 242px;
          margin-right: 13px;
          margin-bottom: 20px;
          position: relative;
          // box-shadow: 0 0 0 1px #dddddd;
          cursor: pointer;
          &:nth-of-type(3n){
            margin-right: 0;
          }
          // &:hover{
          //   box-shadow: 0 0 0 2px #D5AA68;
          // }
          .cover{
            width: 318px;
            height: 180px;
            font-size: 0;
            background: #d8d8d8;
            img{
              width: 318px;
              height: 180px;
              object-fit: cover;
            }
          }
          .title{
            margin-top: 20px;
            margin-bottom: 10px;
            font-size: 16px;
            color: #35343D;
            line-height: 16px;
            padding-left: 8px;
          }
          .time{
            font-size: 16px;
            color:rgba(129,147,174,1);
            line-height: 16px;
            padding: 0 5px;
            font-weight:400;
            font-family:PingFangSC-Regular,PingFang SC;
          }
        }
      }
    }
    .loading {
      height: 40px;
      text-align: center;
      img {
        width: 40px;
      }
    }
    .live-top-btn{
      width: 26px;
      height: 43px;
      background: url("../../assets/images/live-top-btn.png") no-repeat 0 0;
      background-size: 100% 100%;
      position: fixed;
      right: 40px;
      bottom: 40px;
      cursor: pointer;
    }
  }
</style>
